import {
    GET_DETAILED_PRODUCT_TEMPLATE_LIST,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    detailedProductTemplateList: {
        templates: [],
        Loading: false,
        StatusCode: 0,
        StatusMessage: '',
        pagination: {
            pageNum: 0,
            pageLimit: 50,
        },
        totalNoOfResults: 0,
        templateSubCategoryCode:''
    },
    templateDetails: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
    createTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
    updateTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
    orderTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
};

const GetTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
       
        case GET_DETAILED_PRODUCT_TEMPLATE_LIST:
            return {
                ...state,
                detailedProductTemplateList: {
                    ...state.detailedProductTemplateList,
                    templates: [],
                    loading: true,
                    StatusCode: 0,
                    StatusMessage: '',
                    templateSubCategoryCode:action.payload.templateSubCategoryCode,
                    templateNameSearch:action.payload.templateNameSearch
                },
            };
        case GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS:
            return {
                ...state,
                detailedProductTemplateList: {
                    ...state.detailedProductTemplateList,
                    templates: action.payload,
                    loading: false,
                    StatusCode: action.statusCode,
                    StatusMessage: action.statusMessage,
                    pagination: {
                        ...state.detailedProductTemplateList.pagination,
                        ...action.pagination,
                    },
                    totalNoOfResults: action.totalNoOfResults,


                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
                templateDetails: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE:
            return {
                ...state,
                detailedProductTemplateList: {
                    ...state.detailedProductTemplateList,
                    templates: [],
                    loading: false,
                    StatusCode: action.statusCode,
                    StatusMessage: action.statusMessage,
                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };       
        default: {
            return { ...state };
        }
    }
};

export default GetTemplateReducer;
